import { FC } from 'react';

import OldIbanBadge from 'components/OldIbanBadge';
import { DetailedTransactionFragment } from 'features/Bank/pages/Overview/Sidebar/graphql/fragment/detailedTransaction.gql';
import { isTransactionTypeValidToBeTaggued } from 'features/Bank/pages/Overview/Sidebar/OldIbanWarning/utils';
import useGetMigrationToEpData from 'features/Bank/pages/Overview/Transactions/hooks/useGetMigrationToEPData';

interface Props {
  transaction: Pick<
    DetailedTransactionFragment,
    'isOnAgentWallet' | 'type' | 'paymentMethod'
  >;
}

const TransactionOldIbanBadge: FC<Props> = ({ transaction }) => {
  const {
    error,
    hasBeenMigratedToEP,
    hasBeenSevenDaysSinceMigrationStarted,
    loading,
  } = useGetMigrationToEpData();

  if (loading || error !== undefined) {
    return null;
  }

  if (
    hasBeenMigratedToEP &&
    hasBeenSevenDaysSinceMigrationStarted &&
    transaction.isOnAgentWallet &&
    isTransactionTypeValidToBeTaggued(transaction)
  ) {
    return <OldIbanBadge />;
  }

  return null;
};

export default TransactionOldIbanBadge;
